define([
	"csi/store/Names",
	"csi/xml",
], function(Names, xml) {

	var _store;

	return {
		get: function(/*String*/url) {
			// summary: return user name by url
			console.assert(!!_store || !xml.isValidURL(url), "csi/store/UserNames: attempting to get user name before ready.");
			var obj = _store && _store.get(url);
			return obj ? obj[_store.labelProperty] : null;
		},

		load: function() {
			// summary: query for store of user names by url if not already done - used to resolve user names when referenced
			// through node properties (Created By, Published By) that do not support dependency paths
			if (_store) {
				return null;
			}

			_store = Names.createFromType(xml.TYPE_USER, {bSort: false});
			return _store.query();
		},

		store: function() {
			// summary: provide access to the store, but ensure that the first time it is accessed that it is queried so that "get" function will work
			this.load();
			return _store;
		}
	};
});